package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class LoginClientRequestInfo(val email: String, val password: String, val reCaptchaToken: String?, val messageToken: String?)